import classes from "./cpcSearchDropDown.scss";
class SceSelectBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      stylingClass: 'no-icon',
      displayDefaultText: true, 
      isError: false,
      isValid: false,
      isReset: false,
     },
    this.selectedValue = 'invalid',
    this.defaultText = 'Select';
    this.showErrorMessage = false;
    this.forceValidate = false;
    this.showArrow=false;
    this.wasDropdownFocussed=false;
    this.handleClickAway=this.handleClickAway.bind(this);
    this.keysPressed = [];
    this.keyFlag = false;
    this.downarrowblack = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/icon_chevron_black.svg';
  }

  componentWillReceiveProps = (nextProps) => {
    let defaultDataState = { ...this.state };
    let receivedNewProps = false;
    if ('isError' in nextProps && nextProps.isError!=='' && nextProps.isError !== this.state.isError) {
      defaultDataState.isError = (nextProps.isError) ? true : false;
      receivedNewProps = true;
    }
    if ('isValid' in nextProps && nextProps.isValid!=='' && nextProps.isValid !== this.state.isValid) {
      defaultDataState.isValid = (nextProps.isValid) ? true : false;
      receivedNewProps = true;
    }
    if('resetDropdown' in nextProps && nextProps.resetDropdown!=='' && nextProps.resetDropdown !== this.state.isReset){
      defaultDataState.isReset = (nextProps.resetDropdown) ? true : false;
      receivedNewProps = true;
    }
    if(receivedNewProps){ //if received new props set state
      if(nextProps.resetDropdown){ 
        this.resetAll();
      } else{
        this.setState(defaultDataState, () => {
          if (this.forceValidate) { //validation happens only if its in pristine stage
            this.validationStyle();
          }
        });
      }
    }
  }

  resetAll = () => { // reset to default state
    let defaultDataState = { ...this.state };
    defaultDataState.stylingClass = 'no-icon';
    defaultDataState.isError = false;
    defaultDataState.isValid = false;
    this.showErrorMessage = false;
    this.wasDropdownFocussed = false;
    // this.checkDefaultValue();
    this.setState(defaultDataState, function(){
      this.checkDefaultValue();
    });
  }

  checkDefaultValue = () =>{ //check if default exists
    this.forceValidate = true;
    
    document.getElementById(this.props.id).innerHTML = this.defaultText;
    this.selectedValue = 'invalid';

    if (this.props.defaultValue) {
      for (var i = 0; i < this.props.selectBoxData.length; i++) {
        if (this.props.selectBoxData[i].value === this.props.defaultValue) {
          document.getElementById(this.props.id).innerHTML = this.props.selectBoxData[i].name;
          this.selectedValue = this.props.defaultValue;
          break;
        }
      }
    }
  }

  componentDidMount = () => {
    window.addEventListener('click',this.handleClickAway);
    let defaultDataState = { ...this.state };
    (this.props.defaultText)? this.defaultText = this.props.defaultText : null;
    this.checkDefaultValue();
    if('displayDefaultText' in this.props){
      defaultDataState.displayDefaultText = (this.props.displayDefaultText)? true : false;
    }
    this.setState(defaultDataState);
  }
  componentWillUnmount = () => {
    window.removeEventListener('click',this.handleClickAway);
  }

  handleArrows(event){
    event.preventDefault();
    let x = document.getElementById(this.props.id).parentNode.children[3];
    if(x.style.display === 'block'){
      let firstOption = x.firstChild;
      let lastOption = x.lastChild;
      switch(event.keyCode){
      case 38: if(document.activeElement !== firstOption){
        if (document.activeElement.id === this.props.id){
          firstOption.focus();
        }
        else{
          document.activeElement.previousSibling.focus();
        }
      }
        break;
      case 40: if(document.activeElement !== lastOption){
        if (document.activeElement.id === this.props.id){
          firstOption.focus();
        }
        else{
          document.activeElement.nextSibling.focus();
        }
      }
        break;
      }
    }
  }

  handleKeySorts(event) {
    event.preventDefault();
    let x = document.getElementById(this.props.id).parentNode.children[3];
    let listNodes = x.childNodes;
    var list = [];
    var keyString = this.keysPressed.join('').toLowerCase();

    for (var i = 0, len = listNodes.length; i < len; i++) {
      if(listNodes[i].innerText.toLowerCase().startsWith(keyString)) {
        list.push({value: listNodes[i].id, name:listNodes[i].innerText });
      }
    }

    if(x.style.display === 'block'){
      let option = x.firstChild;
      while(option) {
        let index = list.findIndex(item => item.value === option.id);
        let lastIndex = (index === 0 && document.activeElement.id === list[list.length-1].value) ? -1 
          : list.findIndex(item => item.value === document.activeElement.id);
        if(index > -1 ) {
          if(list.length === 1) {
            option.focus();
            break;
          }
          if((document.activeElement.id === option.id ) || (index < lastIndex)) {
            option = index === list.length-1 ? x.firstChild : option.nextSibling;
            continue;
          }
          option.focus();
          break;
        } else {
          option = option.nextSibling;
        }
      }
    }
  }

  handleMouseOver(event){
    event.currentTarget.focus();
  }

  onKeyPressOpenDrawer = (event) => {
    if (event.key === 'Enter' || event.key === ' ' || event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      event.preventDefault();
      this.openDrawer(event);
    }
    else if(event.key === 'Tab'){
      this.validationStyle();
    }
  }

  openDrawer = (e) => { // open the dropdown and remove all stylings
    let defaultDataState = { ...this.state };
    defaultDataState.stylingClass = 'no-icon';
    this.showErrorMessage = false;
    this.forceValidate = false;
    let x = document.getElementById(this.props.id).parentNode.children[3];
    if(x.style.display === 'block'){
      this.closeDrawer();
    }
    else{
      x.style.display = 'block';
      this.showArrow=true;
      this.wasDropdownFocussed=true;
      document.getElementById(this.props.id).classList.add('expanded');
      x.setAttribute('aria-expanded','true');
      for (let i = 0; i < x.children.length; i++) {
        if (x.children[i].getAttribute('value') === this.selectedValue) {
          x.children[i].focus();
          break;
        }
      }
    } 
    this.setState(defaultDataState);
  };

  closeDrawer = () => {
    let x = document.getElementById(this.props.id).parentNode.children[3];
    x.style.display = 'none';
    this.showArrow=false;
    document.getElementById(this.props.id).classList.remove('expanded');
    document.getElementById(this.props.id).focus();
    x.setAttribute('aria-expanded','false');    
    this.wasDropdownFocussed=true;
  }
  
  onKeySelect = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.onSelectOption(event);
    }
    else if(event.keyCode === 38 || event.keyCode === 40){
      this.handleArrows(event);
    }
    else if(event.keyCode === 9){
      this.closeDrawer();
    }
    else if(this.props.isKeyPressSort && (event.keyCode >= 65 && event.keyCode <=90) || (event.keyCode >= 48 && event.keyCode <=57) || (event.keyCode >= 96 && event.keyCode <=105)) {
      this.keysPressed.push(event.key);
      if(!this.keyFlag) {
        setTimeout(() => {
          this.keysPressed = [];
          this.keyFlag = false;
        },700);
      }
      this.keyFlag = true;
      this.handleKeySorts(event);
    }
  }

  onSelectOption = (e) => { //on click of option
    let data = {
      value: e.target.getAttribute('value'),
      name: e.target.innerHTML,
      isValid: (e.target.getAttribute('value').toUpperCase() !== 'INVALID') ? true : false,
      isError: (e.target.getAttribute('value').toUpperCase() !== 'INVALID') ? false : true,
    };
    let id = e.target.id;
    var listFindUl = document.getElementById(id).parentNode;

    listFindUl.parentNode.children[1].innerHTML = document.getElementById(id).innerHTML;

    //update selected value and close drawer
    this.selectedValue = e.target.getAttribute('value');
    this.closeDrawer();
    this.props.handleClick(data);
  }

  validationStyle = () => { //style based on validation
    let defaultDataState = { ...this.state };
    if (this.selectedValue.toUpperCase() === 'INVALID' || this.state.isError) {
      if(!this.props.isOptional){
        defaultDataState.stylingClass = 'border-error no-icon';
        this.showErrorMessage = true;
      }
    } else if (!this.state.isError || this.state.isValid) { 
      defaultDataState.stylingClass = 'border-success';
    }
    this.setState(defaultDataState);
    // this.closeDrawer();
  }

  handleClickAway(e){
    let x = document.getElementById(this.props.id).parentNode.children[3];
    if(e.target.id !== this.props.id && this.wasDropdownFocussed && !e.target.id.includes(this.props.id)){    
      (x.style.display==='block') ? this.closeDrawer() : this.validationStyle();
    }
  }

  render() {          
    let arrow = this.showArrow === true ? 
    <img src={this.downarrowblack} alt="up arrow" className={classes.upArrow} id={this.props.id} tabIndex={this.props.isFocusHidden ? '-1' : '0'} onClick={this.props.isDisabled ? '' :this.openDrawer} onKeyDown={(e)=>this.onKeyPressOpenDrawer(e)}  />:
    <img src={this.downarrowblack} alt="down arrow" className={classes.downArrow} id={this.props.id} tabIndex={this.props.isFocusHidden ? '-1' : '0'} onClick={this.props.isDisabled ? '' :this.openDrawer} onKeyDown={(e)=>this.onKeyPressOpenDrawer(e)}  />;
    let defaultTextJsx;
    if (this.state.displayDefaultText) {
      defaultTextJsx = <li value='invalid' role="tab" aria-selected={this.selectedValue === 'invalid'} id={this.props.id + 'invalid'} tabIndex='0' onClick={(event) => this.onSelectOption(event)} onKeyDown={(event)=>this.onKeySelect(event)} onMouseOver={(e)=>this.handleMouseOver(e)}>
        {this.defaultText}
      </li>;
    }
    let ariaLabel = this.props.ariaLabel ? this.props.ariaLabel : '';
    const customSelectStyle = this.props.isDisabled ? "disabledSelect" : classes.label;
    return (
      <div>
        <div className={'sce-cus-selectBx sce-selectBx ' +classes.selectBox}>
            <div className='select'>

              <select className='s-hidden' aria-label={ariaLabel}>
                <option value=''>{this.props.defaultText}</option>
                {this.props.selectBoxData.map((val) => {
                  <option value={val.value} > {val.name} </option>;
                })}
              </select>

                <div className={customSelectStyle} id={this.props.id} tabIndex={this.props.isFocusHidden ? '-1' : '0'} onClick={this.props.isDisabled ? '' :this.openDrawer} onKeyDown={(e)=>this.onKeyPressOpenDrawer(e)} >
                {this.props.defaultText}</div>
             {arrow}
              <ul className={classes.option} id={this.props.id + 'Ul'} role='tablist' aria-activedescendant={this.props.id + this.selectedValue} aria-label={this.props.id}>
                {defaultTextJsx}
                {this.props.selectBoxData.map((val) => {
                  if(val.disabled){
                    return <li aria-label={val.name} style={{ opacity : 0.5 }} value={val.value} role='tab' id={this.props.id + val.value} tabIndex='0' onMouseOver={(e)=>this.handleMouseOver(e)}>{val.name}</li>;
                  }else{
                    return <li aria-label={val.name} value={val.value} role='tab' id={this.props.id + val.value} aria-selected={val.value===this.selectedValue} tabIndex='0' onClick={(event) => this.onSelectOption(event)} disab onKeyDown={(event)=>this.onKeySelect(event)} onMouseOver={(e)=>this.handleMouseOver(e)}>{val.name}</li>;
                  }
                })}
              </ul>

            </div>
          </div>
       
      </div>
    );
  }
}
export default SceSelectBox;
